import { render, staticRenderFns } from "./DeliveryListView.vue?vue&type=template&id=4c53180c"
import script from "./DeliveryListView.vue?vue&type=script&lang=js"
export * from "./DeliveryListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports